export function formatPrice(value) {
    const price = new Intl.NumberFormat("ru-RU", { style: "decimal", currency: "RUB", currencyDisplay: "symbol" }).format(value).replace(" ", " ");
    return price;
}